export default {
  pageTitle: {
    id: 'bo_seller.kyb.page_title',
    defaultMessage: 'KYB',
  },
} as const
